import React, { useEffect } from "react";
import ShowChapterTopics from "./ShowChapterTopics";
import { getAllChapters, updatePlannerEndpoint } from "../../../actions/tutorFeedActions";
import { connect } from "react-redux";
import { Spinner } from "reactstrap";

const UpdatePlanner = (props) => {
  const { plannerData, setplannerData, updatePlannerFunc, updatePlannerLoader } = props;
  useEffect(() => {
    debugger;
    props.getAllChapters(props.programId);
    debugger;
  }, []);

  return (
    <div className="history mt-2">
      <div id="accordionForUpdatePlanner" class="">
        <div
          className="historyBox d-flex justify-content-between"
          data-toggle="collapse"
          data-target={`#openAccordion`}
          aria-expanded="true"
          aria-controls="collapseOne"
        >
          <h5 className="mb-0">Add more topics to this months planner</h5>
          <i className="fa fa-chevron-down"></i>
        </div>
        <div
          id={`openAccordion`}
          className="collapse accordionBox"
          aria-labelledby="headingOne"
          data-parent="#accordionForUpdatePlanner"
        >
          <ShowChapterTopics
            programId={props.programId}
            plannerData={plannerData}
            setplannerData={setplannerData}
          />
          <div className="text-right mr-3">
            <button
              className="btn btn-success btn-sm"
              onClick={() => updatePlannerFunc()}
              disabled={updatePlannerLoader}
            >
              {updatePlannerLoader ? (
                <>
                  <Spinner size="sm" className="mr-2" />
                  Updating...{" "}
                </>
              ) : (
                "Update Planner"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    programNameState: state.feedTutorRed.programName,
    attendanceData: state.feedTutorRed.attendanceData,
    allPlanners: state.feedTutorRed.allPlanners,
  };
}
export default connect(mapStateToProps, { getAllChapters, updatePlannerEndpoint })(UpdatePlanner);
